<template>
  <div id="content" class="crpg-o-half-plan-common trip half_price">
    <div id="detail" class="crpg-o-half-plan-common__detail">
      <div class="topicpath">
        <MoleculesCommonContentTitleRed :title="content.title" />
        <h2>
          {{ $t("halfPlan.title") }}
        </h2>
      </div>
      <div class="hotels">
        <div
          class="hotel_detail"
          v-for="item in content.content"
          :key="item.image01"
        >
          <MoleculesHalfPlanHotelPlan
            :image01="item.image01"
            :image02="item.image02"
            :image03="item.image03"
            :area="item.area"
            :name="item.name"
            :subName="item.subName"
            :catchTxt="item.catchTxt"
            :puroductNo="item.puroductNo"
            :privilege="item.privilege"
            :priceDate="item.priceDate"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoleculesCommonContentTitleRed from "@/components/molecules/common/ContentTitleRed.vue";
import MoleculesHalfPlanHotelPlan from "@/components/molecules/halfPlan/HalfPlan.vue";

import text from "@/assets/txt/half_plan.json";
var obj = text;

export default {
  name: "Golf",
  components: {
    MoleculesHalfPlanHotelPlan,
    MoleculesCommonContentTitleRed,
  },
  data() {
    return {
      content: obj,
      golfTop: require("@/assets/img/upgrade_plan_top.jpg"),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/organisms/halfPlan/halfPlanContent.scss";
.crpg-o-common-header__header {
  display: none;
}
</style>
